/* External */
import {
  call, put, takeEvery, takeLatest,
} from 'redux-saga/effects';

/* ActionTypes */
import { FETCH_CONTINUE_WATCHING_BY_SHOW_ID, FETCH_SHOW_BY_ID } from './actionTypes';

/* Actions */
import { addToEntities } from '../utils/actions';

/* Sagas */
import { requestSaga } from '../requests/sagas';
import { authenticatedSaga } from '../utils/sagas';

/* Services */
import backendService from '../../services/backendService';

/* Utils */
import { deleteTitleFromContentContinueWatching } from '../utils/preprocessors';

function fetchShowByIdService({ showId }) {
  return backendService.content.v1.getShowDetail(showId);
}

function* fetchShowByIdSaga(action) {
  try {
    const response = yield call(requestSaga, fetchShowByIdService, action);
    if (response) {
      const { normalizedData: { entities } } = response;
      yield put(addToEntities(entities));
    }
  } catch (error) {
    console.error('shows>fetchShowByIdSaga', error);
  }
}

function* fetchShowById() {
  yield takeEvery(FETCH_SHOW_BY_ID, authenticatedSaga(fetchShowByIdSaga));
}

function* continueWatchingShow() {
  yield takeLatest(FETCH_CONTINUE_WATCHING_BY_SHOW_ID, authenticatedSaga(continueWatchingShowSaga));
}

function* continueWatchingShowSaga(action) {
  try {
    const response = yield call(requestSaga, continueWatchingShowService, action);
    if (response) {
      const { normalizedData: { entities = {} } = {} } = response;
      yield put(addToEntities(deleteTitleFromContentContinueWatching(entities, true)));
    }
  } catch (error) {
    console.error('shows>continueWatchingShowSaga', error);
  }
}

function continueWatchingShowService(showId) {
  return backendService.experience.v3.getContinueWatchingShow(showId);
}

export default [
  fetchShowById,
  continueWatchingShow,
];
